<!-- 负责人下拉框 -->
<template>
<div>
	<div v-if="Object.keys(personChargeList).length > 0" class="jl-screen-box">
		<a-select
			mode="multiple" 
			style="min-width: 180px;max-width: 390px;"
			placeholder="请选择投手"
			@change="handleChangeA"
			:filter-option="filterOption"
			:getPopupContainer="getsPopupContainer"
			:value="r_admin_id" 
			allowClear
			showSearch
		  >
			<a-select-option value="-1">未设置</a-select-option>
			<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key">
			  {{value}}
			</a-select-option>
		</a-select>
	</div>
</div>
</template>

<script>
import { putUserList } from '@/request/api'
export default {
	name: 'adminSelec',
	props: ['page_type'],
	data(){
		return {
			r_admin_id: [], // 选择投手
			personChargeList: {}, // 投手
		}
	},
	mounted(){
		let that = this
		// 负责人
		putUserList().then(res=>{
			console.log("负责人",res);
			that.personChargeList = res.data.data.list
		})
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		handleChangeA(e){ // 选择投手
			console.log(e);
			// 未设置的选项与其他选项不可以同时选，所以这里要加限制
			if(e.length > 1 && e.indexOf('-1') > -1){
				this.$message.warning('未设置与其他选项不能同时选择');
			}
			else {
				this.r_admin_id = e
				this.$emit("handle-change",e)
			}
		},
	}
}
</script>

<style>
</style>